
import dayjs from 'dayjs';
import { Qalendar } from 'qalendar';
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import { ScheduleService } from './schedule.service';
import { ToastFactory } from '@/utils/ToastFactory';
const scheduleService = new ScheduleService();

export default defineComponent({
    name: "ListSchedule",
    data() {
        return {
            event: null,
            schedules: [] as any,
            alocations: [] as any,
            params: {
                dateFinish: '',
                dateInit: '',
                page: 0,
                size: 100
            },
            config:{
                locale: navigator.language,
                defaultMode: 'month',
                isSilent: true,
                showCurrentTime: true,
                week:{
                    startsOn: 'sunday',
                },
                dayBoundaries: {
                    start: 8,
                    end: 23,
                },
                style: {
                    FontFamily: 'Inter',
                    colorSchemes: {
                        group: {
                            color: '#153c59',
                            backgroundColor: '#DFEDFC',
                            borderLeft: '4px solid #153c59',
                        },
                    }
                },
            }
        };
    },

    components: { Qalendar },

    computed: {
        ...mapGetters({
            storeSchedule: 'schedule/getSchedule',
        }),
    },

    methods:{
        openEvent(event: any) {
            this.$router.push({ name: 'editSchedule', params: { id: event } });
        },

        confirmDelete(id: any) {
            this.$confirm.require({
                header: this.$t('schedule.delete'),
                message: this.$t('schedule.confirmDelete'),
                accept: () => {
                  this.deleteSchedule(id);  
                },
                reject: () => {
                    
                },
            })        
        },

        deleteSchedule(id: any){
            scheduleService.deleteSchedule(id).then(() => {
                this.getSchedule();
                this.$toast.add(ToastFactory.success(this.$t('toast.sucessScheduleDelete')))
            }).catch((e) => {
                this.$toast.add(ToastFactory.error(this.codeError(e.response.data.code)))
            });
        },

        codeError(error: any): string{
            switch(error){
                case "SCHEDULE_STARTED":
                    return this.$t('errors.scheduleStarted')
                default:
                    return this.$t('toast.errorScheduleDelete');
            }
        },

        getSchedule(): void {
            scheduleService.getSchedule(this.params).then(() => {
                const schedules = this.storeSchedule.content;

                const events: any[] = [];

                schedules.forEach((schedule: any) => {
                    const start = dayjs(schedule.createdAT);
                    const end = dayjs(schedule.dateFinish);
                    const duration = end.diff(start, 'days');

                    for(let i=0; i<=duration; i++){

                        const date = dayjs(start).add(i, 'day');
                        const dayOfWeek = date.day();
                        const mapDays = schedule.calendarList[0].daysWeek.map((day: any) => day.day);

                        if(mapDays.includes(dayOfWeek)){
                            const day = date.format('YYYY-MM-DD');
                            const checkIn = schedule.calendarList[0].checkIn;
                            const checkOut = schedule.calendarList[0].checkOut;

                            const start = day + " " + checkIn;
                            const end = day + " " + checkOut;

                            const event = {
                                id: schedule.id,
                                title: schedule.user.name,
                                time: {
                                    start: start.slice(0, -3),
                                    end: end.slice(0, -3),
                                },
                                isEditable: true,
                                disableDnD: ['month', 'week', 'day'],
                                colorScheme: "group",
                            };

                            events.push(event);
                        }
                    }
                });
                this.schedules = events;

            });
        },

        async getRange(event: any){
            const start = dayjs(event.start).format('YYYY-MM-DD');
            const end = dayjs(event.end).format('YYYY-MM-DD');

            this.params.dateInit = start;
            this.params.dateFinish = end;
            await this.getSchedule();
        },

        async getRangeMode(event: any){
            const start = dayjs(event.period.start).format('YYYY-MM-DD');
            const end = dayjs(event.period.end).format('YYYY-MM-DD');

            this.params.dateInit = start;
            this.params.dateFinish = end;
            await this.getSchedule();
        },

        getCurrentMonth(){
            const start = dayjs().startOf('month').format('YYYY-MM-DD');
            const end = dayjs().endOf('month').format('YYYY-MM-DD');

            this.params.dateInit = start;
            this.params.dateFinish = end;
        }
    },

    mounted() {
        this.getCurrentMonth();
        this.getSchedule();
    },
});
